import React from 'react';
import { Button } from "MWComponents";

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
        { mode } = model,
        pledge = "credit-line-pledge",
        noPledge = "credit-line-no-pledge",
        radioButtons = model.getTerms().map((rate, index) => (
          <button className={`term-btn ${model.getTerm() === index ? 'active' : ''}`} name="term" onClick={calc.handleChange} value={index}>
            {rate} {calc.l10n('CALCULATOR_DAYS')}
          </button>
        )),
      amountBtns = (
        <div className="calculator-amount-wrapper">
            <button className={`amount-btn ${250000 === Number(model.getCreditSum()) ? 'active' : ''}`} name="creditSum"  onClick={calc.handleChange} value={250000}>
                {(250000).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
            </button>
            <button className={`amount-btn ${500000 === Number(model.getCreditSum()) ? 'active' : ''}`} name="creditSum"  onClick={calc.handleChange} value={500000}>
                {(500000).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
            </button>
          <button className={`amount-btn ${2500000 === Number(model.getCreditSum()) ? 'active' : ''} ${mode === noPledge ? 'hidden' : ''}`} name="creditSum"  onClick={calc.handleChange} value={2500000}>
            {(2500000).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
          </button>
          <button className={`amount-btn ${5000000 === Number(model.getCreditSum()) ? 'active' : ''} ${mode === noPledge ? 'hidden' : ''}`} name="creditSum"  onClick={calc.handleChange} value={5000000}>
            {(5000000).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
          </button>
          <button className={`amount-btn ${1000000 === Number(model.getCreditSum()) ? 'active' : ''} ${mode === noPledge ? '' : 'hidden'}`} name="creditSum"  onClick={calc.handleChange} value={1000000}>
            {(1000000).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
          </button>
          <button className={`amount-btn ${1500000 === Number(model.getCreditSum()) ? 'active' : ''} ${mode === noPledge ? '' : 'hidden'}`} name="creditSum"  onClick={calc.handleChange} value={1500000}>
            {(1500000).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
          </button>
        </div>
      );

    return (
        <React.Fragment>
            <div className="calculator-controllers">
                <p className="calc-title" dangerouslySetInnerHTML={{__html: calc.l10n('CREDIT_CALCULATOR_NAME')}}></p>
                <div className="mode-switchers">
                    <button name={pledge}
                        className={`${mode === pledge && "selected"} btn-transparent`}
                        onClick={calc.toggleMode}>
                        {calc.l10n("CALCULATOR_CREDLINE_PLEDGE")}
                    </button>
                    <button name={noPledge}
                        className={`${mode === noPledge && "selected"} btn-transparent`}
                        onClick={calc.toggleMode}>
                        {calc.l10n("CALCULATOR_CREDLINE_NO_PLEDGE")}
                    </button>
                </div>
                <p className="notification">
                    {calc.l10n(mode === pledge ?
                        "CALCULATOR_CREDLINE_MAX_PLEDGE_SUM" :
                        "CALCULATOR_CREDLINE_MAX_NO_PLEDGE_SUM")}{" "}{model.getMaxSumEdge().toLocaleString()}{" "}{calc.l10n('UAH_ICON')}
                </p>

                <div className="controller-block">
                  <div className="calc-block-title" >{calc.l10n('CALCULATOR_CREDIT_SUM')}<span className='calc-block-title-gray'> ({calc.l10n('CALCULATOR_CREDIT_SUM_FROM')} {model.getMinSumEdge().toLocaleString('RU-ru')} {calc.l10n('CALCULATOR_CREDIT_SUM_TO')} {model.getMaxSumEdge().toLocaleString('RU-ru')} {calc.l10n('UAH_ICON')})</span></div>
                    <div className="calculator-slider-wrapper">
                      <div className="calculator-input-wrapper">
                        <input name="creditSum" type="text"
                               className="calculator-slider-value"
                               value={model.getCreditSum().toLocaleString('RU-ru')}
                               min={model.getMinSumEdge()}
                               max={model.getMaxSumEdge()}
                               onChange={calc.handleChangeInput}
                               onBlur={calc.blurChangeInput}>
                        </input>
                        <span ref={calc.hiddenValue} className='hidden-value'>{model.getCreditSum().toLocaleString('RU-ru')}</span>
                        <span style={{left: `${calc.state.valueWith + 4}px`}}>{calc.l10n('UAH_ICON')}</span>
                      </div>
                        <div className="calculator-slider">
                            <input type="range"
                                name="creditSum"
                                className="calculator-sum-slide"
                                onChange={calc.handleChange}
                                value={model.getCreditSum()}
                                min={model.getMinSumEdge()}
                                max={model.getMaxSumEdge()}
                                step={model.getSumStep()}
                                style={{background: `linear-gradient(90deg, #4BDF7F ${calc.state.rangePercent}%, transparent ${calc.state.rangePercent}%)`}}
                            />
                        </div>
                    </div>
                </div>
              {amountBtns}
              <div className='calc-term-title'>{calc.l10n('CALCULATOR_CREDLINE_TRANCHE_TERM')} <span className='calc-term-title-gray'>{calc.l10n('CALCULATOR_CREDLINE_TRANCHE_TERM_2')}</span></div>
              <div className="calculator-terms-wrapper">
                {radioButtons}
              </div>

            </div>
        </React.Fragment>
    );
}
